import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteLeft } from '@fortawesome/free-solid-svg-icons';
import { TESTIMONIALS } from '../../constants';
import { Stars, SectionTitle } from '../ui';

const Testimonials = () => {
  return (
    <section id="depoimentos" className="py-12 sm:py-20 lg:py-28 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-goshine-dark to-goshine-navy/30" />
      
      <div className="container mx-auto px-4 relative z-10">
        <SectionTitle 
          title="O que nossos clientes"
          highlight="dizem"
          description="A satisfação dos nossos clientes é nossa maior recompensa."
        />

        {/* Testimonials Grid */}
        <div className="flex flex-col gap-4 sm:gap-5 md:grid md:grid-cols-3 lg:gap-8">
          {TESTIMONIALS.map((testimonial, index) => (
            <div 
              key={index} 
              className="bg-gradient-to-br from-goshine-navy to-goshine-navy-light border border-white/10 p-6 lg:p-8 rounded-2xl relative hover:border-goshine-orange/30 transition-colors duration-300"
            >
              {/* Quote Badge */}
              <div className="absolute -top-3 left-6">
                <div className="w-10 h-10 lg:w-12 lg:h-12 bg-goshine-orange rounded-full flex items-center justify-center shadow-lg shadow-goshine-orange/30">
                  <FontAwesomeIcon icon={faQuoteLeft} className="text-white text-sm lg:text-base" />
                </div>
              </div>

              <div className="mt-4 lg:mt-6">
                {/* Stars */}
                <div className="flex gap-1 mb-4 lg:mb-5">
                  <Stars />
                </div>

                {/* Quote */}
                <p className="text-gray-300 text-base lg:text-lg leading-relaxed mb-5 lg:mb-6">
                  "{testimonial.text}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-3 pt-4 lg:pt-5 border-t border-white/10">
                  <div className="w-10 h-10 lg:w-12 lg:h-12 bg-goshine-orange/20 rounded-full flex items-center justify-center">
                    <span className="text-goshine-orange font-bold text-sm lg:text-base">
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <div>
                    <p className="font-semibold text-white lg:text-lg">{testimonial.name}</p>
                    <p className="text-goshine-orange text-sm lg:text-base">{testimonial.car}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Google Rating Badge */}
        <div className="mt-10 lg:mt-14 text-center">
          <div className="inline-flex items-center gap-2 lg:gap-3 bg-white/5 border border-white/10 rounded-full px-5 py-2.5 lg:px-8 lg:py-4">
            <div className="flex -space-x-1">
              <Stars className="text-goshine-orange text-sm lg:text-base" />
            </div>
            <span className="text-gray-300 text-sm lg:text-base font-medium">5.0 no Google</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
